<div class="addOn"
  [class.opened]="isAddonOpen"
  *ngIf="vinInfo['vin_number']?.value || vinInfo['plate_number']?.value || vinInfo['vehicle_item_code']">
  <button type="button" class="btn addOn-toggle" (click)="addOnToggle()">
    <ng-container [ngSwitch]="isAddonOpen">
      <ion-icon name="information-circle-outline" class="ion-lg" *ngSwitchCase="false"></ion-icon>
      <ion-icon name="information-circle" class="ion-lg" *ngSwitchCase="true"></ion-icon>
    </ng-container>
  </button>
  <div class="addOn__info ml-auto">
    <div class="row mb-2">
      <div class="col-sm-6">
        <div class="form-group mb-0">
          <div class="custom-control custom-switch m-0">
            <input type="radio" 
              [checked]="currentLang === 'en'"
              name="lang" 
              value="en" 
              class="custom-control-input" id="eng"
              (change)="setLocale('en')">
            <label class="custom-control-label" for="eng">
              In English
            </label>
          </div>
        </div>
      </div>
  
      <div class="col-sm-6">
        <div class="form-group mb-0">
          <div class="custom-control custom-switch m-0">
            <input type="radio"
              [checked]="currentLang === 'ar'"
              name="lang" 
              value="ar" 
              class="custom-control-input" id="ar"
              (change)="setLocale('ar')">
            <label class="custom-control-label" for="ar">
              {{ 'login.arabic' | translate }}
            </label>
          </div>
        </div>
      </div>
    </div>
    <span class="addOn__infoItem mb-2"><span class="font-weight-medium">VIN No.:</span> {{ vinInfo['vin_number'].value }}</span>
    <span class="addOn__infoItem mb-2"><span class="font-weight-medium">Plate No.:</span> {{ vinInfo['plate_number'].value }}</span>
    <span class="addOn__infoItem"><span class="font-weight-medium">Item Code:</span> {{ vinInfo['vehicle_item_code'] }}</span>
  </div>
</div>